import React, { useEffect, useState, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import "../../assets/css/addEuipment.css";
import { ToastContainer, toast } from "react-toastify";
import fetchWrapper from "./../../AuthMiddleware/FetchWrapper";
import Loader from "../../Components/LoaderAndSpinner/Loader";

const UpdateAssetGroup = () => {
  const [errors, setErrors] = useState({});
  const [assetGroupCode, setAssetGroupCode] = useState("");
  const [assetGroupName, setAssetGroupName] = useState("");
  const [loading, setLoading] = useState(false);
  const [equipments, setEquipments] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);
  const [allChecked, setAllChecked] = useState(false);

  const navigate = useNavigate();
  const { asset_group_id } = useParams();

  const fetchEquipments = useCallback(async () => {
    try {
      const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipment/getall`;
      const data = await fetchWrapper(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      });
      setEquipments(data.data);
    } catch (error) {
      console.error("Error fetching equipments:", error);
    }
  }, []);

  const getAssetGroup = useCallback(async () => {
    try {
      const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-group/${asset_group_id}`;
      const data = await fetchWrapper(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      });
      const { asset_group_name, asset_group_code, equipments } = data;
      setAssetGroupName(asset_group_name);
      setAssetGroupCode(asset_group_code);
      setCheckedItems(equipments);
      //   setAllChecked(equipments.length === equipments.length);
    } catch (error) {
      console.error("Error fetching asset group:", error);
    }
  }, [asset_group_id]);
  useEffect(() => {
    fetchEquipments();
    getAssetGroup();
  }, []); // Empty dependency array ensures it runs only once

  //   useEffect(() => {
  //     fetchEquipments();
  //     getAssetGroup();
  //   }, [fetchEquipments, getAssetGroup]);

  const handleRowCheckboxChange = (id) => {
    setCheckedItems((prevCheckedItems) => {
      const newCheckedItems = prevCheckedItems.includes(id)
        ? prevCheckedItems.filter((item) => item !== id)
        : [...prevCheckedItems, id];
      setAllChecked(newCheckedItems.length === equipments.length);
      return newCheckedItems;
    });
  };

  const handleHeaderCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setCheckedItems(
      isChecked ? equipments.map((equipment) => equipment._id) : []
    );
    setAllChecked(isChecked);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);


    // Ensure the state is updated properly
    // const trimmedAssetGroupName = assetGroupName.trim();
    // const trimmedAssetGroupCode = assetGroupCode.trim();

    // Check if required fields are empty

    try {
      await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset-group/update/${asset_group_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            asset_group_name: assetGroupName,
            asset_group_code: assetGroupCode,
            equipments: checkedItems,
          }),
        }
      );

      setLoading(false);
      toast.success("Asset Group updated successfully");
      navigate("/all_assets_group");
    } catch (error) {
      setLoading(false);

      if (error.response) {
        const errorData = error.response;
        if (errorData.errors.equipments) {
          toast.error("Select Atleast One Equipement");

        }
        setErrors(errorData.errors || {});
        // toast.error(errorData.message || "Error updating asset group");
      } else {
        toast.error("Error in updating asset group");
      }
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="container">
          <div className="pt-3 pb-0 d-flex justify-content-between">
            <div>
              <h5>Update Asset Group</h5>
              <nav
                className="breadcrumb-nav show-breadcrumb"
                aria-label="breadcrumb"
              >
                <ol className="breadcrumb template-breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">My Assets</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/all_assets_group">Asset Groups</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Update Asset Group
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="addEuipment">
            <div>
              <div className="addEuipment-header">
                <h4>Update Asset Group</h4>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="addEuipment-form">
                  <div className="d-flex gap-3">
                    <div className="col d-flex flex-column addEuipment-form-col">
                      <label className="addEuipment-form-text">
                        Asset Group Code<span className="text-danger"> *</span>
                      </label>
                      <input
                        className={`form-control ${errors.asset_group_code ? "is-invalid" : ""
                          }`}
                        placeholder="Asset Group Code"
                        style={{ padding: "8px 8px", height: "48px" }}
                        value={assetGroupCode}
                        onChange={(e) => setAssetGroupCode(e.target.value)}
                      />
                      {errors.asset_group_code && (
                        <div className="invalid-feedback">
                          {errors.asset_group_code}
                        </div>
                      )}
                    </div>
                    <div className="col d-flex flex-column addEuipment-form-col">
                      <label className="addEuipment-form-text">
                        Asset Group Name <span className="text-danger"> *</span>
                      </label>
                      <input
                        className={`form-control ${errors.asset_group_name ? "is-invalid" : ""
                          }`}
                        placeholder="Asset Group Name"
                        style={{
                          padding: "8px 8px",
                          height: "48px",
                        }}
                        value={assetGroupName}
                        onChange={(e) => setAssetGroupName(e.target.value)}
                      />
                      {errors.asset_group_name && (
                        <div className="invalid-feedback">
                          {errors.asset_group_name}
                        </div>
                      )}
                    </div>
                  </div>
                  <div style={{ marginTop: "-10px" }}>
                    <div className="table-responsive">
                      <table className="table align-middle table-text">
                        <thead className="table-head align-middle">
                          <tr>
                            <th className="table-check">
                              <input
                                type="checkbox"
                                checked={allChecked}
                                onChange={handleHeaderCheckboxChange}
                              />
                            </th>
                            <th className="col">ID</th>
                            <th className="col">Equipment Code</th>
                            <th className="col">Equipment Name</th>
                            <th className="col">Capacity</th>
                          </tr>
                        </thead>
                        <tbody>
                          {equipments.map((equipment, index) => (
                            <tr
                              key={equipment._id}
                              className={
                                equipment.status ? "" : "disabled text-muted"
                              }
                            >
                              <td className="table-check">
                                <input
                                  type="checkbox"
                                  checked={checkedItems.includes(equipment._id)}
                                  onChange={() =>
                                    handleRowCheckboxChange(equipment._id)
                                  }
                                />
                              </td>
                              <td className="col">{index + 1}</td>
                              <td>{equipment.equipment_code ?? ""}</td>
                              <td>{equipment.equipment_name ?? ""}</td>
                              <td>{equipment.capacity ?? ""}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="addEuipment-footer">
                  <button
                    type="button"
                    className="addEuipment-discard-btn"
                    onClick={() => navigate("/all_assets_group")}
                  >
                    Discard
                  </button>
                  <button type="submit" className="addEuipment-update-btn">
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
          />
        </div>
      )}
    </>
  );
};

export default UpdateAssetGroup;
